// src/utils/format.js

export const formatDate = (date) => {
  if (
    !date ||
    date === "SIN FECHA" ||
    date === "0000-00-00" ||
    date === "0000-00-00T00:00:00.000Z" ||
    date === "1899-11-30T00:00:00.000Z"
  ) {
    return "SIN FECHA";
  }

  const cleanDate = date.split("T")[0]; // solo la parte YYYY-MM-DD
  const [year, month, day] = cleanDate.split("-");

  return `${day}/${month}/${year.slice(-2)}`;
};

export const formatTimeFromTS = (ts) => {
  if (!ts) return "";
  const str = ts.toString().padStart(6, "0");
  const hh = str.slice(0, 2);
  const mm = str.slice(2, 4);
  const ss = str.slice(4, 6);
  return `${hh}:${mm}:${ss}`;
};
